export default __webpack_public_path__ + "static/media/profile_active.5489a1c9.svg";